// extracted by mini-css-extract-plugin
export default {"videoBg":"videoBg_videoBg__DUp0k","bgDarken":"videoBg_bgDarken__xhZ+T","hidden":"videoBg_hidden__bAp69"};